const TRANSMITTED_TYPES = {
  REMOTE_HANDOFF: 'remote_handoff',
  AIRDROP: 'airdrop',
};

export default TRANSMITTED_TYPES;
